import React from 'react';
import DarkModeToggle from './DarkModeToggle';
import LogoAnimation from './animations/LogoAnimation';

const Navbar = () => {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="bg-white dark:bg-[#162b32]">
      <div className="max-w-7xl mx-auto px-5 py-5 md:px-8 lg:px-12">
        <div className="flex items-center justify-between gap-6">
          <a href="/" className="flex items-center gap-3" aria-label="Nepal Market home">
            <LogoAnimation />
            <div className="hidden sm:block">
              <div className="text-xl font-black tracking-tight text-[#162b32] dark:text-white">Nepal Market</div>
              <div className="text-[11px] font-medium tracking-wide text-[#92a3a9]">PRICE COMPARISON FOR NEPAL</div>
            </div>
          </a>

          <nav className="items-center hidden gap-7 md:flex" aria-label="Main navigation">
            <a href="/" className="text-sm font-bold uppercase text-[#162b32] hover:text-[#36a0c7] dark:text-white">Home</a>
            <button type="button" onClick={() => scrollTo('results')} className="text-sm font-bold uppercase text-[#162b32] hover:text-[#36a0c7] dark:text-white">Compare</button>
            <button type="button" onClick={() => scrollTo('categories')} className="text-sm font-bold uppercase text-[#162b32] hover:text-[#36a0c7] dark:text-white">Categories</button>
            <button type="button" onClick={() => scrollTo('why-nepal-market')} className="text-sm font-bold uppercase text-[#162b32] hover:text-[#36a0c7] dark:text-white">Why Us</button>
          </nav>

          <div className="flex items-center gap-4">
            <button type="button" onClick={() => scrollTo('results')} className="hidden px-5 py-2.5 text-xs font-black uppercase tracking-wide text-white bg-[#fa471d] rounded-sm hover:bg-[#e43d16] sm:inline-flex">Compare Prices</button>
            <DarkModeToggle />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
